<template>  
  <div class="atlas-app">
    <router-view />
  </div>
  <div class="atlas-overlay" v-if="searching">
    <Spinner class="atlas-overlay__spinner" />
  </div>
</template>

<script setup lang="ts">
import Spinner from '@/components/spinner/Spinner.vue';
import { useApi } from '@/services/api-service';
import { useStore } from "@/stores/store";
import { ISearchResult } from '@/interfaces/search/ISearchResult';
import { onBeforeMount } from 'vue';
import { useFilterApply } from '@/services/filter-apply-service';
import { useSearch } from '@/services/search-service';

const store = useStore();
const { get: search, loading: searching } = useApi(`/atlas/Search`);
const { applyFilters } = useFilterApply();
const { sortSearchResult } = useSearch();
const searchLoadErrorMessage = 'Just nu har vi problem med att visa kartan, prova igen om en stund.';

onBeforeMount(() => {
  store.apiErrorMessage = null;
  search<ISearchResult>().then((response: ISearchResult) => {
    store.searchResult = response;
    store.originalSearchResult = response;
    applyFilters();
    sortSearchResult('name', store.sorting.descending);
  }).catch(() => {
    store.apiErrorMessage = searchLoadErrorMessage;
    store.searchResult = null;
    store.originalSearchResult = null;
  });
});

</script>
